import corporates from "./corporates.component";
import corporatesUrls from "./corporates.urls";
import CorporatesTransforms from "./corporates.transforms";

const corporatesModule = angular
  .module("app.components.corporates", [])
  .component("corporatesPage", corporates)
  .service("CorporatesTransforms", CorporatesTransforms)
  .config(corporatesUrls);

export default corporatesModule;



// WEBPACK FOOTER //
// ./src/pages/corporates/corporates.module.js